module.exports = __webpack_public_path__ + "img/banner.4f1c774a.png";